export const MAX_ATTACHMENT_FILE_SIZE = 10000000; // 10MB
export const MOBILE_WIDTH = 600; // threshold to switch over to mobile styling
export const GUIDANCE_MIN_WIDTH = 150;
export const GUIDANCE_MAX_WIDTH = 400;

export const SUBMISSION_STATUS = {
    NEW: '', // rfi is being created by the contractor. this won't actually get saved on the backend, it's just a consistent way to track the inital form status on the external site
    SUBMITTED: 'Submitted', // submitted by contractor to be looked at by designer staff
    IN_PROGRESS: 'Response In-Progress', // designer staff is currently making changes to the rfi
    DC_REVIEW: 'DC Review', // designer is done crafting a response to the rfi and has passed it on to be DC Reviewed
    PENDING_DISTRIBUTION: 'Pending Distribution', // DC review has been performed and is awaiting the response to be sent back to the contractor
    COMPLETE: 'Complete' // response has been sent back to the contractor
}

export const ACCEPTED_FILE_TYPES = {
    'image/png': '.png', 
    'image/jpeg': '.jpeg', 
    'application/msword': '.doc', 
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx', 
    'text/plain': '.txt', 
    'application/pdf': '.pdf'
}

export const FORM_TYPES = {
    INPUT: 1,
    TEXT_AREA: 2,
    DATE: 3,
    CHECKBOX: 4,
    RADIO_BUTTON: 5,
};

export const TOAST_TYPES = {
    SUCCESS: 1,
    WARNING: 2,
    ERROR: 3,
    INFO: 4,
};

export const CLASSIFICATION = {
    FOUO: 'For Official Use Only',
    UNCLASSIFIED: 'Unclassified'
};

export const FORM_META = {
    contractNumber: {
        key: 'contractNumber',
        label: 'Contract Number',
        isRequired: false,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    taskOrderNumber: {
        key: 'taskOrderNumber',
        label: 'Task Order Number',
        isRequired: false,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    projectName: {
        key: 'projectName',
        label: 'Project Name',
        isRequired: true,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    projectLocation: {
        key: 'projectLocation',
        label: 'Project Location',
        isRequired: true,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    contractor: {
        key: 'contractor',
        label: 'Contractor',
        isRequired: true,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    rfiNumber: {
        key: 'rfiNumber',
        label: 'RFI Number',
        isRequired: false,
        pnnlOnly: true,
        type: FORM_TYPES.INPUT
    },
    submissionDate: {
        key: 'submissionDate',
        label: 'Date',
        isRequired: true,
        pnnlOnly: false,
        type: FORM_TYPES.DATE
    },
    subject: {
        key: 'subject',
        label: 'Subject',
        isRequired: true,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    submittersName: {
        key: 'submittersName',
        label: "Submitter's Name",
        isRequired: true,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    submittersEmail: {
        key: 'submittersEmail',
        label: "Submitter's Email",
        isRequired: true,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    submittersPhone: {
        key: 'submittersPhone',
        label: "Submitter's Phone Number",
        isRequired: true,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    srNumber: {
        key: 'srNumber',
        label: 'SR Number',
        isRequired: false,
        pnnlOnly: true,
        type: FORM_TYPES.INPUT
    },
    challengeLocation: {
        key: 'challengeLocation',
        label: 'Location of Challenge',
        isRequired: true,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    pages: {
        key: 'pages',
        label: 'Drawing Set Page(s)',
        isRequired: false,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    references: {
        key: 'references',
        label: 'Other References',
        isRequired: false,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    informationRequested: {
        key: 'informationRequested',
        label: 'Problem/Information Requested',
        isRequired: true,
        pnnlOnly: false,
        type: FORM_TYPES.TEXT_AREA
    },
    requestedBy: {
        key: 'requestedBy',
        label: 'Requested By',
        isRequired: true,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    replyNeededDate: {
        key: 'replyNeededDate',
        label: 'Date Reply Needed',
        isRequired: true,
        pnnlOnly: false,
        type: FORM_TYPES.DATE
    },
    proposedResolution: {
        key: 'proposedResolution',
        label: "Contractor's Interpretation and Proposed Resolution",
        isRequired: false,
        pnnlOnly: false,
        type: FORM_TYPES.TEXT_AREA
    },
    scheduleImpact: {
        key: 'scheduleImpact',
        label: 'Potential Schedule Impact',
        isRequired: false,
        pnnlOnly: false,
        type: FORM_TYPES.CHECKBOX
    },
    scheduleDescription: {
        key: 'scheduleDescription',
        label: 'Describe Impact',
        isRequired: false,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    costImpact: {
        key: 'costImpact',
        label: 'Potential Cost Impact',
        isRequired: false,
        pnnlOnly: false,
        type: FORM_TYPES.CHECKBOX
    },
    costDescription: {
        key: 'costDescription',
        label: 'Describe Impact',
        isRequired: false,
        pnnlOnly: false,
        type: FORM_TYPES.INPUT
    },
    response: {
        key: 'response',
        label: 'Response',
        isRequired: true,
        pnnlOnly: true,
        type: FORM_TYPES.TEXT_AREA
    },
    isClarificationOnly: {
        key: 'isClarificationOnly',
        label: 'Clarification Only',
        isRequired: false,
        pnnlOnly: true,
        type: FORM_TYPES.CHECKBOX
    },
    isCnRequired: {
        key: 'isCnRequired',
        label: 'CN Required',
        isRequired: false,
        pnnlOnly: true,
        type: FORM_TYPES.CHECKBOX
    },
    isAttached: {
        key: 'isAttached',
        label: 'Attached',
        isRequired: false,
        pnnlOnly: true,
        type: FORM_TYPES.CHECKBOX
    },
    responseBy: {
        key: 'responseBy',
        label: 'Response By',
        isRequired: true,
        pnnlOnly: true,
        type: FORM_TYPES.INPUT
    },
    responseDate: {
        key: 'responseDate',
        label: 'Date',
        isRequired: true,
        pnnlOnly: true,
        type: FORM_TYPES.DATE
    },
    jobTitle: {
        key: 'jobTitle',
        label: 'Title',
        isRequired: true,
        pnnlOnly: true,
        type: FORM_TYPES.INPUT
    },
    classification: {
        key: 'classification',
        label: 'Classification',
        isRequired: false,
        pnnlOnly: true,
        type: FORM_TYPES.RADIO_BUTTON
    },
    status: {
        key: 'status',
        label: 'Status',
        isRequired: false,
        pnnlOnly: true,
        type: null
    }
}